/* eslint-disable no-useless-constructor */
/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { connect } from 'react-redux'

class Logo extends Component {
    constructor(props){
        super(props)
    }

    render(){
        let titleComponent = undefined;
        const titleClassName = this.props.theme === 'dark' ? 'ho-title-dark' : 'ho-title-light';
        const logClassName = this.props.theme === 'dark' ? 'ho-title-log-dark' : 'ho-title-log-light';

        if (this.props.collapsed){
            titleComponent = <div className={logClassName} onClick={() => {
                window.goToMenu('/')
            }}>
                <img style={{display: 'inlineBlock',height: '32px',}} alt="" src="/logo.png" ></img>
            </div> 
        }else{
            titleComponent = <p className={titleClassName} >应急指挥全流程业务管理平台</p>
        }
        return titleComponent;
    }
}

export default connect(
    null, 
    null
)(Logo);